import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="page-state">
      <h1>Nincs ilyen oldal</h1>
      <Link className="button button--primary" to="/">
        Vissza az áttekintéshez
      </Link>
    </div>
  );
}
